import { extendTheme } from '@chakra-ui/react';
import Button from './components/Button';
import Text from './components/Text';
import Tabs from './components/Tabs';
import Checkbox from './components/Checkbox';
import Select from './components/Select';
import Input from './components/Input';
import Switch from './components/Switch';

export default extendTheme({
  styles: {
    global: {
      '::-webkit-scrollbar': {
        width: '16px',
        height: '8px',
        borderRadius: '8px',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        borderRadius: '8px',
      },
      '::-webkit-scrollbar-thumb:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
    },
  },
  fonts: {
    body: `"Rethink Sans", sans-serif`,
    heading: `"Rethink Sans", sans-serif`,
  },
  colors: {
    rentals: {
      primary: { btn: '#1D1840', txt: '#161236' },
      states: { approved: '#3CB18B', processing: '#F0873A', failed: '#C81757' },
    },
    palomma: { primary: { logo: '#4012AB' } },
  },
  components: { Button, Text, Tabs, Checkbox, Select, Input, Switch },
});
